import { Component, OnInit, Input, EventEmitter, Output, ElementRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';

import { QueryParameterValue } from '@classes/query/query-parameter-value';

@Component({
  selector: 'app-multiple-select-filter',
  templateUrl: './multiple-select-filter.component.html',
  styleUrls: ['./multiple-select-filter.component.scss']
})
export class MultipleSelectFilterComponent implements OnInit {
  // @ViewChild('search', { read: ElementRef, static: true }) searchControl: ElementRef;
  selectedOptions: string[];
  @Input() label: string;
  @Input() filteredOptions: QueryParameterValue[];
  @Input() availableOptions: QueryParameterValue[];
  @Output() selectedOptionsChanged: EventEmitter<string[]> = new EventEmitter<string[]>();

  searchControl = new FormControl<string>('');

  constructor() { }

  ngOnInit() {
    this.onSearchChange();
  }

  clearSearch(event) {
    event.stopPropagation();
    this.resetSearchValue();
  }

  onSearchChange() {
    this.searchControl.valueChanges
      .subscribe(filterValue => {
        this.filteredOptions = this.availableOptions
          .filter(option => option.label.toLowerCase().indexOf(filterValue.toLowerCase()) !== -1);
      });
  }

  private resetSearchValue() {
    this.searchControl.setValue('');
    // this.searchControl.nativeElement.value = '';
    // this.onSearchChange('');
  }

  onOpenMultiSelect() {
    this.resetSearchValue();
  }

  onSelectChange(): void {
    this.selectedOptionsChanged.emit(this.selectedOptions);
  }
}
